$(document).ready(function() {
    // přepnutí okna tlačítkem
    (function() {
        var $button = $('.JS-readmore-projekty');
        if ($button.length === 0)
            return;
        $button.click(function(event) {
            $('.projektyTabs a[href="#popis"]').trigger('click');
        });
    }());
});